<template>
  <div>
    <div class="flex flex-wrap justify-between items-center mb-4">
      <h5>Phone</h5>
      <vs-button  @click="phoneNumberAddpopup = true"
        >Add</vs-button
      >
    </div>
    <div class="table-responsive">
      <table class="light_blue_table w-full">
        <tbody>
          <tr v-for="(phone, index) in phoneAvailability" :key="index">
            <td>
              <div class="flex items-center">
                <span class="material-icons-outlined small_icon">phone</span>
                Phone
              </div>
            </td>
            <td>{{ phone.phone }}</td>
            <td>
              <vs-checkbox
                :checked="phone.default"
                @change="handlePhonedefault(index)"
                >Mark default</vs-checkbox
              >
            </td>
            <td>
              <vs-dropdown>
                <vs-button
                  class="btn-drop"
                  type="flat"
                  icon="more_vert"
                ></vs-button>
                <vs-dropdown-menu>
                  <vs-dropdown-item
                    @click="handleeditphone(index)"
                  >
                    Edit
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    :disabled="phone.default === 1"
                    @click="handledeleteAndPopup(index)"
                  >
                    Delete
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <vs-popup
      classContent="popup-example"
      title="Delete"
      :active.sync="phoneDeletepupup"
    >
      <h4>Are you sure to delete this ?</h4>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click="handleDeletePhone()">Confirm</vs-button>
        <vs-button
          type="border"
          color="danger"
          @click="phoneDeletepupup = false"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>
    <vs-popup
      classContent="popup-example"
      title="Add Phone"
      :active.sync="phoneNumberAddpopup"
    >
      <form data-vv-scope="add">
        <vs-row>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <vs-input
              v-validate="'required|numeric'"
              name="phone"
              v-model="phoneNumber"
              class="custom_Input"
              label="Phone number"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
              style="width: 100%"
            />
            <span v-show="errors.has('add.phone')" class="text-danger">{{
              errors.first("add.phone")
            }}</span>
          </vs-col>
        </vs-row>
      </form>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click.prevent="handleSavePhoneNumber"
          >Save</vs-button
        >
        <vs-button
          type="border"
          color="danger"
          @click="phoneNumberAddpopup = false"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>

    <vs-popup
      classContent="popup-example"
      title="Edit Phone"
      :active.sync="phoneeditpopup"
    >
      <form data-vv-scope="edit">
        <vs-row>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <vs-input
              v-validate="'required'"
              name="phone"
              v-model="editphone"
              class="custom_Input"
              label="Phone number"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
              style="width: 100%"
            />
            <span v-show="errors.has('edit.phone')" class="text-danger">{{
              errors.first("edit.phone")
            }}</span>
          </vs-col>
        </vs-row>
      </form>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click.prevent="handleUpdatePhone"
          >Save</vs-button
        >
        <vs-button type="border" color="danger" @click="phoneeditpopup = false"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>
  </div>
</template>
<script>
import { TeacherUpdate } from '@/api/teacher'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'

export default {
  name: 'phone',
  props: {
    phoneProps: {
      required: true,
      type: Array,
      default: () => []
    },
    havePermission:{
      default: false
    }
  },
  created () {
    const role_permission = localStorage.getItem('role_permission')
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Teachers')
    }
  },
  mixins: [PermissionMiddleware],
  data () {
    return {
      phoneNumberAddpopup: false,
      phoneDeletepupup: false,
      deleteIndex: null,
      phoneeditpopup: false,
      editphone: null,
      editindex: null,
      phoneNumber: null,
      phoneAvailability: []
    }
  },
  watch: {
    phoneProps: {
      deep: true,
      immediate: true,
      handler () {
        this.phoneAvailability = this._.cloneDeep(this.phoneProps)
      }
    }
  },

  methods: {
    handlePhonedefault (index) {
      this.phoneAvailability.map((item) => {
        item.default = 0
      })
      this.phoneAvailability[index].default = 1
      this.editindex = index
      this.editphone = this.phoneAvailability[index].phone
      this.handleUpdatePhone()
    },
    handleDeletePhone () {
      this.phoneAvailability.splice(this.deleteIndex, 1)
      this.handlePhonesave()
    },
    handledeleteAndPopup (index) {
      this.phoneDeletepupup = true
      this.deleteIndex = index
    },
    handleeditphone (index) {
      this.editphone = this.phoneAvailability[index].phone
      this.phoneeditpopup = true
      this.editindex = index
    },
    handleUpdatePhone () {
      this.$validator.validateAll('edit').then((result) => {
        if (result) {
          this.phoneAvailability[this.editindex].phone = this.editphone
          this.handlePhonesave()
        }
      })
    },
    handleSavePhoneNumber () {
      this.$validator.validateAll('add').then((result) => {
        if (result) {
          const payload = {
            phone: this.phoneNumber,
            default: 0
          }
          this.phoneAvailability.push(payload)

          this.handlePhonesave()
        }
      })
    },
    async handlePhonesave () {
      try {
        const customer_id = localStorage.getItem('customer_id')
        const payload = {
          updateField: {
            phone: this.phoneAvailability
          }
        }
        const { data } = await TeacherUpdate(
          payload,
          JSON.parse(localStorage.getItem('userInfo')).id,
          customer_id
        )
        this.phoneNumber = null
        this.phoneNumberAddpopup = false
        this.phoneDeletepupup = false
        this.phoneeditpopup = false

        this.$emit('setAfterUpdate', data)

        this.showSuccessMessage('Success', 'Updated Successfully', 'success')
      } catch (error) {
        console.log(error)
        this.showSuccessMessage('Error', error.data.message, 'danger')
      }
    }
  }
}
</script>